import { Box } from '@mui/material';
import { useLogin } from '../Contexts/AuthProvider/AuthProvider';
import { Outlet } from 'react-router-dom';

interface MainLayoutProps {
  children?: React.ReactNode;
}

export default function MainLayout({ children }: MainLayoutProps) {
  const { user } = useLogin();

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column',
      height: '100vh',
      width: '100%',
      overflow: 'hidden', // Previene scroll del contenedor padre
      bgcolor: '#ffffff'
    }}>
      <Box sx={{ 
        flex: 1, 
        display: 'flex', 
        flexDirection: 'column',
        overflow: 'hidden', // El contenido interno maneja su propio scroll
        width: '100%',
        height: '100%'
      }}>
        {children}
        <Outlet />
      </Box>
    </Box>
  );
}
